import Vue from "vue";
import axios from "axios";
import Cookies from "js-cookie";

const timeout = 30 * 1000; //30秒
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const newAxios = axios.create({ timeout, baseURL: process.env.VUE_APP_API_URL });
axios.interceptors.request.use(
  function (config) {
    var token = Cookies.get("token");
    if(token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    if(Object.prototype.toString.call(response.data) === '[object Object]') {
      if(response.data && response.data.code === 'NOT_FOUND') {
        return Promise.reject({
          response: {
            status: 404,
            data: {
              message: 'Data Not Found'
            }
          },
          stack: JSON.stringify(response.data)
        });
      }
      if('success' in response.data) {
        return response.data || {};
      }
    }
    return response;
  },
  function (error) {
    const mainDomain = process.env.VUE_APP_MAIN_DOMAIN;
    const passportUrl = process.env.VUE_APP_PASSPORT_URL;
    if (error.response.status == 401) {
      return newAxios
        .post("/spms/securitys/refreshToken", {
          refreshToken: Cookies.get("refreshToken"),
        })
        .then(
          (res) => {
            Cookies.set("token", res.data.token, { domain: mainDomain, expires: 365 });
            Cookies.set("refreshToken", res.data.refreshToken, { domain: mainDomain, expires: 365 });
            error.config.headers.Authorization = "Bearer " + res.data.token; // 设置新token再发送原来的请求
            return newAxios(error.config);
          },
          (err) => {
            Cookies.remove("token", { domain: mainDomain });
            Cookies.remove("refreshToken", { domain: mainDomain });
            window.location.replace(
              passportUrl +
              "/#/login?redirectUrl=" +
              encodeURIComponent(location.href)
            ); // token刷新失败
          }
        );
    } else {
      return Promise.reject(error);
    }
  }
);

function isFunc(args) {
  return Object.prototype.toString.call(args) === "[object Function]";
}

function failure(err) {
  err = err && err.response;
  // if (!err) return $msg.error("请求错误");
  // let msg = (err.data || {}).message || "系统异常";
  if(err.status === 503) {
    $msg.error('系统升级中，请稍候再试');
    return;
  }
  $msg.error((err.status || 500) + ": " + msg);
}

function req(url, data, config, method, isList) {
  let vm = this;
  data = data || {};
  config = config || {};
  let args = {
    url: url,
    method: method,
    timeout: timeout,
  };
  method == "get" ? (args.params = data) : (args.data = data);
  let axiosCfg = config.axios || {};
  for (let k in axiosCfg) {
    if (axiosCfg[k]) args[k] = axiosCfg[k];
  }
  if (isList || method == "get") {
    vm.setLoaded(false);
    vm.setLoadedText("loading...");
  }
  return axios(args)
    .then(function (resp) {
      if (isList || method == "get") {
        vm.setLoaded(true);
        vm.setLoadedText("");
        if (Object.prototype.toString.call(resp.data) === "[object Array]") {
          if (!resp.data.length) vm.setLoadedText("No data.");
        }
      }
      if (isFunc(config.success)) {
        config.success.call(vm, resp.data, resp);
      } else {
        return Promise.resolve(resp.data);
      }
    })
    .catch(function (err) {
      // 状态码不在2xx范围内或者success里抛出错误
      if (isList || method == "get") {
        vm.setLoaded(true);
        vm.setLoadedText("数据加载出错！");
      }
      if (!config.noFailureMsg) failure(err);
      if (process.env.NODE_ENV === "development") return Promise.reject(err);
      if (!config.success) return Promise.reject(err);
    });
}

function post(url, data, config) {
  return req.call(this, url, data, config, "post");
}

function get(url, data, config) {
  return req.call(this, url, data, config, "get");
}

function list(url, data, config) {
  return req.call(this, url, data, config, "post", true);
}

function postFile(url, data, callback) {
  let param = new FormData();
  for (let k in data) {
    param.append(k, data[k]);
  }
  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .post(url, param, config)
    .then((resp) => {
      if (isFunc(callback)) {
        callback.call(this, resp.data, resp);
      } else {
        return Promise.resolve(resp.data);
      }
    })
    .catch(function (err) {
      failure(err);
      if (process.env.NODE_ENV === "development") return Promise.reject(err);
      if (!callback) return Promise.reject(err);
    });
}

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$list = list;
Vue.prototype.$postFile = postFile;
